import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { stateCodeArray } from "../../services/fakeDB/ListUser";
import TwoFactorIcon from "../../assets/images/2fa.png";
import $ from "jquery";
import fileDownload from "js-file-download";
import { MdnDispatchMode, KeepMdnMode, classificationName, translateMdnValueGcpWire } from "../../utils/enums";

let o = {
  AdminCount: 0,
  CredentialText: "",
  DomainBox: "",
  DomainId: 0,
  DomainName: null,
  ExternalId: "",
  IDs: [],
  Id: null,
  IsCsrOrg: false,
  IsEpicOrganization: false,
  KeepMDN: false,
  NPI: "",
  OrgEmailCount: 0,
  OrganizationKind: null,
  OrganizationName: "",
  OrganizationType: "",
  OrgClassificationCode: "",
  ParentOrg: "",
  ParentOrganizationId: null,
  ParentOrganizationName: null,
  Specialties: [],
  Addresse: {
    FirstLine: "",
    SecondLine: "",
    City: "",
    State: "",
    County: "",
    PostalCode: "",
    Country: "",
    Phone: "",
    PhoneExt: "",
    Fax: "",
    FaxExt: "",
    AddressType: 0,
    IsCertAddress: true,
  },
  SubOrgCount: 0,
  UserCount: 0,
  UserEmailCount: 0,
  VendorId: 0,
  VendorVal: "",
  XDRDoNOTGenerateXDM: false,
  XDREnabled: false,
  xdrConfig: null,
  AllowTwoFactor: false,
  ApplicationAccessXDR: false,
  /*  ApplicationAccessENS: false,*/
  specializationCode: "",
  GatewayModeEnabled: false,
  MdnDispatchMode: MdnDispatchMode.Conditional,
};

const DetailsOrg = ({ orgDetails, orgEdit }) => {
  const navigate = useNavigate();
  const [flag, setFlag] = useState(false);
  const {
    userRole,
    userToken,
    setCustomerObj,
    sharedObject,
    SetSharedObject,
    XdrArr,
    userSession,
    backendTarget,
  } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    setCustomerObj: state.setCustomerObj,
    sharedObject: state.sharedObject,
    SetSharedObject: state.SetSharedObject,
    XdrArr: state.XdrArr,
    userSession: state.userSession,
    backendTarget: state.backendTarget,
  }));
  const isGcpUser = !!userSession?.is_gcp_user || backendTarget === "gcp";
  const showOnDemandOption = isGcpUser;
  const [processingDetails, SetProcessingDetails] = useState(false);
  const [addressObject, SetAddressObject] = useState({});
  const [specailityObject, SetSpecailityObject] = useState({});
  const [PINValue, SetPINValue] = useState("");
  const [IDsValue, SetIDsValue] = useState("");
  const [secondValue, SetSecondValue] = useState("");
  const [thirdValue, SetThirdValue] = useState("");
  const [addIdFlag, SetIdFlag] = useState(false);
  const [collapse, SetCollapse] = useState(false);
  const [answers, setAnswers] = useState(o);
  // answers.keepMDN / answers.mdnDispatchMode come straight from the API response (no
  // buildForm-style normalization here), so for GCP orgs they are wire values and must be
  // translated to this portal's internal numbering before comparing against KeepMdnMode /
  // MdnDispatchMode below (see CPPCON-1212).
  const keepMdnInternal = showOnDemandOption && typeof answers.keepMDN === "number"
    ? translateMdnValueGcpWire(answers.keepMDN)
    : answers.keepMDN;
  const mdnDispatchModeInternal = showOnDemandOption && typeof answers.mdnDispatchMode === "number"
    ? translateMdnValueGcpWire(answers.mdnDispatchMode)
    : answers.mdnDispatchMode;
  const [XDRConfigObj, setXDRArrConfigObj] = useState({});
  const [custCheckboxes, SetCustCheckboxes] = useState({});
  const [permissions, SetPermissions] = useState({});
  const [notExists, SetNotExists] = useState(true);
  const [customerName, SetCustumerName] = useState("");
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [msg, SetMsg] = useState(false);
  const [uncheckMsg, SetUncheckMsg] = useState(false);
  const [createUser, setCreateUser] = useState(false);
  const firstFocusRef = useRef(true); // ref for first focusable element in modal

  // Move focus into modal on open
  useEffect(() => {
    const modalEl = document.getElementById("detailsOrgModal");
    if (!modalEl) return;
    const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
    modalEl.addEventListener("shown.bs.modal", onShown);
    return () => modalEl.removeEventListener("shown.bs.modal", onShown);
  }, []);

  useEffect(() => {
    SetNotExists(true);
    SetSharedObject("CSRUploadPage", "");
    setAnswers(orgDetails);
    SetErrCreateMsg(false);
    SetSharedObject("orgActionObj", orgDetails);
    if (orgDetails) {
      SetAddressObject(orgDetails?.addresses[0]);
      SetSpecailityObject(orgDetails?.specialties[0]);
      GetXdrConfig(orgDetails?.xdrConfig?.id);
      customerPermission(orgDetails?.vendorId);
    }
  }, [orgDetails]);

  const customerPermission = (customerId) => {
    var customer = sharedObject.vendorsObj.find((element) => {
      return element.id === parseInt(customerId);
    });
    SetCustumerName(customer?.name);
    var ob = {
      ApplicationAccessXDR: customer?.applicationAccessXDR,
      ApplicationAccessENS: customer?.applicationAccessENS,
      TwoFactorAuth: customer?.twoFactorAuth,
      EmailForwardingType: customer?.emailForwardingType,
      ShareDirectoryListing: customer?.directorySharing,
      GatewayModeEnabled: customer?.gatewayModeEnabled,
    };
    if (
      ob.emailForwardingType === 0 &&
      ob.twoFactorAuth === false &&
      ob.applicationAccessXDR === false &&
      ob.applicationAccessENS === false &&
      ob.directorySharing === false &&
      ob.gatewayModeEnabled === false
    ) {
      SetPermissions(true);
    } else {
      SetPermissions(false);
    }
    SetCustCheckboxes(ob);
  };

  const GetXdrConfig = async (vl) => {
    let tempXDR = {};
    if (vl) {
      for (let el of XdrArr) {
        if (el.id === parseInt(vl)) {
          tempXDR = el;
          break;
        }
      }
    }
    await setXDRArrConfigObj(tempXDR);
  };

  const viewPIN = async () => {
    SetProcessingDetails(true);
    let call = "/organization/ViewPin?orgId=" + answers.id;
    const res = await CallAPI(call, null, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetPINValue(res.data.data);
      $("#TlsPinModal").modal("show");
      SetProcessingDetails(false);
    } else if (res.status === "SERVERERROR") {
      let str = "We could not find a PIN for this organization.";
      SetMsg(str);
      SetErrCreateMsg(true);
      SetProcessingDetails(false);
    }
  };

  const DeleteId = async (el) => {
    SetProcessingDetails(true);
    let call =
      "/organization/DeleteOrgId?orgId=" +
      answers.id +
      "&RecordId=" +
      el.recordId;
    const res = await CallAPI(call, null, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      orgEdit(answers, "orgSearch");
      SetProcessingDetails(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessingDetails(false);
    }
  };

  const orgEditHandle = async (obj) => {
    SetProcessingDetails(true);
    await orgEdit(obj, "orgSearch");
    SetProcessingDetails(false);
  };

  const SearchNpi = async (valId) => {
    SetProcessingDetails(true);
    SetNotExists(true);
    let flag = false;
    let call = "/organization/SearchNPI?searchNPI=" + valId + "&npiType=1";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      if (dt && Object.keys(dt).length > 0 && dt.constructor === Object) {
        SetNotExists(true);
        flag = true;
      } else {
        SetNotExists(false);
        flag = false;
      }
    } else if (res.status === "SERVERERROR") {
      SetNotExists(false);
      SetProcessingDetails(false);
      flag = false;
    }
    SetProcessingDetails(false);
    return await flag;
  };

  const AddId = async () => {
    SetIdFlag(true);
    let IdType = IDsValue === "NPI" ? 0 : IDsValue === "State" ? 1 : 2;
    if (IDsValue === "NPI") {
      let npiFlag = await SearchNpi(secondValue);
      if (!npiFlag) return;
    }
    let obj = {
      RecordId: 0,
      IDType: IdType,
      Value: IDsValue === "State" ? thirdValue : secondValue,
      IssuingAuthority: IDsValue === "State" ? secondValue : thirdValue,
    };
    SetProcessingDetails(true);
    let call = "/organization/addOrgId?orgId=" + answers.id;
    const res = await CallAPI(call, obj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetIDsValue("");
      SetSecondValue("");
      SetThirdValue("");
      SetIdFlag(false);
      orgEdit(answers, "orgSearch");
      SetProcessingDetails(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessingDetails(false);
    }
  };
  function isNumeric(n) {
    return (!isNaN(parseFloat(n)) && isFinite(n)) || n === "" || n === ".";
  }

  const UncheckCSR = async () => {
    SetProcessingDetails(true);
    SetUncheckMsg(false);
    let call = "/organization/DeleteCSRCert?orgId=" + answers.id;
    const res = await CallAPI(call, null, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      if (res.data.data === "notExists") {
        SetMsg("TLS Certificate does not exists.");
        SetUncheckMsg(true);
      }
      SetSharedObject("CSRUploadFlag", false);
      let det = { ...sharedObject.orgActionObj, isCsrOrg: false };
      SetSharedObject("orgActionObj", det);
      CloseUncheckCSRmodal();
      SetProcessingDetails(false);
    } else if (res.status === "SERVERERROR") {
      // let msg = res.data.data;
      // if (Object.keys(msg).length > 0 && msg.constructor === Object) {
      //   let str = "<div>";
      //   for (let el in msg) {
      //     str += `${el}`;
      //   }
      //   str += "</div>";
      SetMsg(
        "A system error occurred searching for your results. Please contact support for further assistance.",
      );
      // } else {
      //   SetMsg(msg);
      // }
      SetErrCreateMsg(true);
      SetProcessingDetails(false);
    }
  };

  const getCustomer = () => {
    var obj = sharedObject.vendorsObj;
    var customer;
    for (var i = 0; i < obj.length; i++) {
      var c = obj[i];
      if (c.name === customerName) {
        customer = c;
      }
    }

    CloseDetailOrg();
    SetSharedObject("CustomerObj", customer);
    setFlag("/customers");
  };

  useEffect(() => {
    if (flag) navigate(flag, { replace: true });
    setCreateUser(
      userSession?.CreateUserFlag ||
        userRole === "SES ADMINISTRATOR" ||
        userRole === "SYSTEMADMINISTRATOR",
    );
  }, [flag, navigate]);

  const downloadTLS = async () => {
    SetProcessingDetails(true);
    let call = "";
    let extention = "";
    if (answers.isCsrOrg) {
      call = "/organization/DownloadCSRCert?orgId=" + answers.id;
      extention = ".cer";
    } else {
      call = "/organization/DownloadOrgTLS?orgId=" + answers.id;
      extention = ".pfx";
    }
    const res = await CallAPI(call, null, "post", userToken, false, true);
    await SetSharedObject("ResponseCode", res.code);
    SetProcessingDetails(false);
    if (res.status === "SUCCESS") {
      let fileName = answers.organizationName + extention;
      let file = res.data.data;
      console.log(file.fileContents);
      fileDownload(file.fileContents, fileName);
      SetProcessingDetails(false);
    } else if (res.status === "SERVERERROR") {
      let msg =
        "Could not generate a TLS cert for: " + answers.organizationName;
      if (Object.keys(msg).length > 0 && msg.constructor === Object) {
        let str = "<div>";
        for (let el in msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetMsg(str);
      } else {
        SetMsg(msg);
      }
      SetErrCreateMsg(true);
      SetProcessingDetails(false);
    }
  };
  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6,
    )}-${phoneNumber.slice(6, 10)}`;
  }

  const TwoFactorSignUp = async () => {
    $("#TwoFactorSignupModal").modal("show");
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;

    if (processingDetails) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processingDetails]);

  const closeModal = (modalId) => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    $(`#${modalId}`).modal("hide");
  };

  const CloseDetailOrg = () => closeModal("detailsOrgModal");
  const CloseUncheckCSRmodal = () => closeModal("UncheckCSRmodal");
  const CloseTlsPinModal = () => closeModal("TlsPinModal");
  const CloseTwoFactorModal = () => closeModal("TwoFactorSignupModal");

  // Add Escape key handler for modals
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        // Close any open modal
        if ($("#detailsOrgModal").hasClass("show")) CloseDetailOrg();
        if ($("#UncheckCSRmodal").hasClass("show")) CloseUncheckCSRmodal();
        if ($("#TlsPinModal").hasClass("show")) CloseTlsPinModal();
        if ($("#TwoFactorSignupModal").hasClass("show")) CloseTwoFactorModal();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div className="DetailsOrg">
      <div
        className="modal fade"
        id="detailsOrgModal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="detailsOrgModalTitle"
        aria-describedby="detailsOrgModalDesc"
        style={{ zIndex: "1061 !important" }}
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <h2
                className="modal-title spacer-inline text-size3"
                id="detailsOrgModalTitle"
              >
                Organization Details
              </h2>
              <button
                type="button"
                className="close"
                aria-label="Close organization details"
                onClick={CloseDetailOrg}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <p id="detailsOrgModalDesc" className="sr-only">
                View organization details including contact, permissions,
                certificates, and identity documents.
              </p>
              <div className="modal-content-body container">
                <div className="details-header blk-clr">
                  <i
                    className="bi bi-building-fill text-size5"
                    aria-hidden="true"
                  ></i>
                  <div className="text-size6 ft-wt ">
                    {answers?.organizationName}
                  </div>
                  <div className="sp-margin1">
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      ref={firstFocusRef}
                      aria-label={`Edit ${answers?.organizationName || "this organization"}`}
                      onClick={(e) => {
                        orgEdit(answers, false);
                      }}
                    >
                      <i
                        className="bi bi-pencil-square sp-margin5"
                        aria-hidden="true"
                      ></i>
                      EDIT
                    </button>
                  </div>
                </div>
                <section>
                  <dl className="sp-mx7">
                    <dt>Address:</dt>
                    <dd className="sp-margin5">{addressObject?.firstLine},</dd>
                    <dd className="sp-margin5">{addressObject?.secondLine}</dd>
                    <dd className="sp-margin5">{addressObject?.city},</dd>
                    <dd className="sp-margin5">
                      {addressObject?.state} {addressObject?.postalCode}
                    </dd>
                  </dl>
                  <dl>
                    <dt className="sp-margin5">Phone:</dt>
                    <dd className="sp-margin5">
                      {addressObject?.phone ? (
                        <a
                          href={`tel:${addressObject.phone.substring(0, 10)}`}
                          aria-label={`Call phone number ${formatPhoneNumber(addressObject.phone.substring(0, 10))}`}
                        >
                          {formatPhoneNumber(
                            addressObject.phone.substring(0, 10),
                          )}
                        </a>
                      ) : null}
                    </dd>
                    <dt className="sp-margin5">Ext:</dt>
                    <dd className="sp-margin5">
                      {addressObject?.phone?.length > 10
                        ? addressObject?.phone?.substring(
                            10,
                            addressObject?.phone.length,
                          )
                        : ""}
                    </dd>
                    <br />
                    <dt className="sp-margin5">Fax:</dt>
                    <dd className="sp-margin5">
                      {formatPhoneNumber(addressObject?.fax?.substring(0, 10))}
                    </dd>
                    <dt className="sp-margin5">Ext:</dt>
                    <dd>
                      {addressObject?.fax?.length > 10
                        ? addressObject?.fax?.substring(
                            10,
                            addressObject?.fax.length,
                          )
                        : ""}
                    </dd>
                  </dl>
                </section>
                <hr />
                {/*User Info*/}
                <section className="field-wrapper">
                  <dl>
                    {userRole !== "SES ADMINISTRATOR" &&
                    userRole !== "SYSTEMADMINISTRATOR" ? null : (
                      <>
                        <dt className="sp-margin5">Customer:</dt>
                        <dd>
                          <button
                            className="btn btn-link p-0"
                            type="button"
                            aria-label={customerName || "View customer"}
                            onClick={() => {
                              getCustomer();
                            }}
                          >
                            {customerName}
                          </button>
                        </dd>{" "}
                        <br />
                      </>
                    )}
                    <dt className="sp-margin5">Domain:</dt>
                    <dd> {answers.domainName} </dd>
                    <br />

                    {answers.parentOrganizationId !== 1 ? (
                      <>
                        <dt className="sp-margin5">Parent Organization:</dt>
                        <dd>
                          <button
                            type="button"
                            className="btn btn-link p-0"
                            onClick={() => {
                              let ob = {
                                id: answers.parentOrganizationId,
                                OrganizationName:
                                  answers.parentOrganizationName,
                                ShowParent: "ShowParent",
                              };
                              orgEditHandle(ob);
                            }}
                          >
                            {answers.parentOrganizationName}
                          </button>
                        </dd>
                        <br />
                      </>
                    ) : null}
                    <dt className="sp-margin5">Organization Type:</dt>
                    <dd>{answers.organizationType}</dd>
                    <br />
                    <dt className="sp-margin5">Organization Classification:</dt>
                    <dd>{classificationName(sharedObject?.orgClassifications, answers?.orgClassificationCode)}</dd>
                    <br />
                    <dt className="sp-margin5">External ID:</dt>
                    <dd>{answers.externalId}</dd>
                    <br />
                    <dt className="sp-margin5">Created By:</dt>
                    <dd>{answers?.createdBy?.split("|")[0]}</dd>
                    <br />
                    <dt className="sp-margin5">Date Created:</dt>
                    <dd>
                      {answers?.dateCreated
                        ? new Date(answers?.dateCreated).toLocaleString(
                            "en-US",
                            { hour12: false },
                          )
                        : null}
                    </dd>
                    <br />
                    <dt className="sp-margin5">Modified By:</dt>
                    <dd>{answers?.modifiedBy?.split("|")[0]}</dd>
                    <br />
                    <dt className="sp-margin5">Last Modified:</dt>
                    <dd>
                      {answers?.dateModified
                        ? new Date(answers?.dateModified).toLocaleString(
                            "en-US",
                            { hour12: false },
                          )
                        : null}
                    </dd>
                  </dl>
                </section>

                <section
                  className="field-wrapper"
                  aria-labelledby="specialtyHeading"
                >
                  <span className="custom-label" id="specialtyHeading">
                    Specialty
                  </span>
                  <dl className="sub-catg sp-mx7">
                    <dt className="sp-margin5">Type:</dt>
                    <dd> {specailityObject?.type}</dd>
                    <br />
                    <dt className="sp-margin5">Classification:</dt>
                    <dd>{specailityObject?.classification}</dd>
                    <br />
                    <dt className="sp-margin5">Specialization:</dt>
                    <dd>{specailityObject?.specialization}</dd>
                  </dl>
                </section>

                <div
                  className="sp-margin3"
                  aria-labelledby="totalCategoriesAvailable"
                >
                  <label
                    htmlFor="totalCategoriesAvailable"
                    id="totalCategoriesAvailable"
                  >
                    TOTAL AVAILABLE
                  </label>
                </div>
                <div className="total-av-container">
                  {/* Organizations */}
                  <div className="total-av-wrapper">
                    <button
                      type="button"
                      className="circle-plus"
                      aria-label="Add sub organization"
                      onClick={() => {
                        let o = {
                          ...orgDetails,
                          Name: orgDetails.organizationName,
                          Type: "sub",
                          OrgType: "org",
                          VendorId: orgDetails.vendorId,
                        };
                        setCustomerObj(o);
                        SetSharedObject("orgActionObj", o);
                        CloseDetailOrg();
                        setFlag("/organization-registration");
                      }}
                    >
                      +
                    </button>
                    <div className="suborg-av">
                      <button
                        type="button"
                        className="btn btn-success"
                        aria-label={`View ${answers?.subOrgCount ?? 0} sub-organization${(answers?.subOrgCount ?? 0) !== 1 ? "s" : ""}`}
                        onClick={(e) => {
                          CloseDetailOrg();
                          if (answers?.subOrgCount > 0) {
                            orgEdit(answers, false, true);
                          }
                        }}
                      >
                        <i className="fas fa-building" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div className="totalnumber">
                      Orgs: {answers?.subOrgCount}
                    </div>
                  </div>

                  {/* Add Users */}
                  <div className="total-av-wrapper">
                    {isGcpUser ? null : createUser === true ||
                      userRole === "SES ADMINISTRATOR" ||
                      userRole === "SYSTEMADMINISTRATOR" ? (
                      <button
                        type="button"
                        className="circle-plus"
                        aria-label="Add User"
                        onClick={() => {
                          SetSharedObject(
                            "orgObjectTFA",
                            answers?.twoFactorAuth,
                          );
                          CloseDetailOrg();
                          SetSharedObject("orgActionObjForUser", orgDetails);
                          SetSharedObject("orgActionObj", orgDetails);
                          setFlag("/user-registration");
                        }}
                      >
                        +
                      </button>
                    ) : (
                      <span
                        className="circle-plus-disabled"
                        aria-label="Add User - Not Enabled"
                        aria-disabled="true"
                        tabIndex={-1}
                      >
                        +
                      </span>
                    )}
                    <div className="users-av">
                      <button
                        type="button"
                        className="btn btn-success"
                        aria-label={`View ${answers?.userCount ?? 0} user${(answers?.userCount ?? 0) !== 1 ? "s" : ""}`}
                        onClick={(e) => {
                          SetSharedObject(
                            "orgObjectTFA",
                            answers?.twoFactorAuth,
                          );
                          if (answers?.userCount > 0) {
                            CloseDetailOrg();
                            let o = {
                              OrganizationId: answers.id,
                              Name: answers.organizationName,
                              Navigate: "org",
                              Flag: "userOrgDetails",
                              AdminsOnly: false,
                            };
                            SetSharedObject("UserIdEmail", o);
                            setFlag("/users");
                          }
                        }}
                      >
                        <i className="fas fa-users" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div className="totalnumber">
                      Users: {answers?.userCount}
                    </div>
                  </div>

                  {/* Emails */}
                  <div className="total-av-wrapper">
                    <button
                      type="button"
                      className="circle-plus"
                      aria-label="Add Email"
                      onClick={() => {
                        let o = {
                          ...answers,
                          Id: orgDetails.id,
                          Name: answers.organizationName,
                          Navigate: "orgEmails",
                          Flag: "orgEmails",
                          Domain: answers.domainName,
                        };
                        SetSharedObject("UserIdEmail", o);
                        SetSharedObject("sharedObject", o);
                        CloseDetailOrg();
                        setFlag("/emails");
                      }}
                    >
                      +
                    </button>
                    <div className="org-emails-av">
                      <button
                        type="button"
                        className="btn btn-success"
                        aria-label={`View ${answers?.orgEmailCount ?? 0} email${(answers?.orgEmailCount ?? 0) !== 1 ? "s" : ""}`}
                        onClick={(e) => {
                          if (answers?.orgEmailCount > 0) {
                            let o = {
                              ...answers,
                              Id: orgDetails.id,
                              Name: answers.organizationName,
                              Navigate: "orgEmails",
                              Flag: "orgEmails",
                              Domain: answers.domainName,
                            };
                            SetSharedObject("UserIdEmail", o);
                            SetSharedObject("sharedObject", o);
                            CloseDetailOrg();
                            setFlag("/emails");
                          }
                        }}
                      >
                        <i className="fas fa-envelope" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div className="totalnumber">
                      Emails: {answers?.orgEmailCount}
                    </div>
                  </div>

                  {/* Admins */}
                  <div className="total-av-wrapper">
                    <div className="admin-av">
                      <button
                        type="button"
                        className="btn btn-success"
                        aria-label={`View ${answers?.adminCount ?? 0} admin${(answers?.adminCount ?? 0) !== 1 ? "s" : ""}`}
                        onClick={(e) => {
                          if (answers?.adminCount > 0) {
                            let o = {
                              //...sharedObject.UserIdEmail,
                              OrganizationId: answers.id,
                              Name: answers.organizationName,
                              Navigate: "org",
                              Flag: "adminUserOrgDetails",
                              AdminsOnly: true,
                            };
                            SetSharedObject("UserIdEmail", o);
                            CloseDetailOrg();
                            setFlag("/users");
                          }
                        }}
                      >
                        <i className="fas fa-users-cog" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div className="totalnumber">
                      Admins: {answers?.adminCount}
                    </div>
                  </div>
                </div>

                {/*Services */}
                <section
                  className="field-wrapper label-divider"
                  aria-labelledby="permissionsTitle"
                >
                  <h6 className="spacer-inline sp-pad9" id="permissionsTitle">
                    Permissions
                  </h6>
                </section>
                {permissions === true ? (
                  <div className="sub-catg ctr" role="status">
                    There are no permissions for this organization.
                  </div>
                ) : null}
                <section
                  className="field-wrapper"
                  aria-label="Permission settings"
                >
                  <dl>
                    <dt>Two-Factor Authentication:</dt>
                    <dd>
                      {custCheckboxes.TwoFactorAuth ? (
                        <span>
                          {answers?.twoFactorAuth === true
                            ? "Enabled"
                            : "Disabled"}
                        </span>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-outline-info"
                          aria-haspopup="dialog"
                          onClick={TwoFactorSignUp}
                        >
                          Learn More
                        </button>
                      )}
                    </dd>
                    <br />

                    {custCheckboxes.ApplicationAccessXDR ? (
                      <>
                        <dt>XDR-Access:</dt>
                        <dd>
                          {answers.applicationAccessXDR
                            ? "Enabled"
                            : "Disabled"}
                        </dd>
                        <br />
                      </>
                    ) : null}
                    {custCheckboxes.ShareDirectoryListing ? (
                      <>
                        <dt>Share Directory Listings:</dt>
                        <dd>
                          {answers?.shareDirectoryListing
                            ? "Enabled"
                            : "Disabled"}
                        </dd>
                        <br />
                      </>
                    ) : null}
                    {custCheckboxes.GatewayModeEnabled ? (
                      <>
                        <dt>Gateway Mode:</dt>
                        <dd>
                          {answers?.gatewayModeEnabled ? "Enabled" : "Disabled"}
                        </dd>
                        <br />
                      </>
                    ) : null}
                    {custCheckboxes.ApplicationAccessENS ? (
                      <>
                        <dt>Notify:</dt>
                        <dd>
                          {answers?.applicationAccessENS
                            ? "Enabled"
                            : "Disabled"}
                        </dd>
                        <br />
                      </>
                    ) : null}
                    {custCheckboxes.EmailForwardingType &&
                    custCheckboxes?.EmailForwardingType === 1 ? (
                      <>
                        <dt>DirectRoute:</dt>
                        <dd>
                          {answers?.emailForwardingType === 1
                            ? "Enabled"
                            : "Disabled"}
                        </dd>
                        <br />
                      </>
                    ) : null}
                    {custCheckboxes.EmailForwardingType &&
                    custCheckboxes?.EmailForwardingType === 2 ? (
                      <>
                        <dt>Advanced DirectRoute:</dt>
                        <dd>
                          {answers?.emailForwardingType === 2
                            ? "Enabled"
                            : "Disabled"}
                        </dd>
                      </>
                    ) : null}
                  </dl>
                </section>

                {/*Email Delivery*/}
                <section aria-labelledby="emailDeliveryTitle">
                    <div className="field-wrapper label-divider">
                        <h6 className="spacer-inline sp-pad9" id="emailDeliveryTitle">
                            Email Delivery
                        </h6>
                    </div>
                    <dl className="field-wrapper">
                        <dt>Keep MDN:</dt>
                        <dd>
                            {keepMdnInternal === KeepMdnMode.Yes
                            ? "Yes"
                            : (showOnDemandOption && keepMdnInternal === KeepMdnMode.OnDemand)
                            ? "On Demand"
                            : "No"}
                        </dd>
                        <br />
                        <dt htmlFor="SendMDN">Send Dispatched MDN:</dt>
                        <dd>
                            {mdnDispatchModeInternal === MdnDispatchMode.AlwaysSend
                            ? "Yes"
                            : (showOnDemandOption && mdnDispatchModeInternal === MdnDispatchMode.OnDemand)
                            ? "On Demand"
                            : "No"}
                        </dd>
                        <br />

                    {custCheckboxes.ApplicationAccessXDR &&
                    answers.applicationAccessXDR ? (
                      <>
                        {custCheckboxes.ApplicationAccessXDR ? (
                          <dl>
                            <dt>Inbound XDR:</dt>
                            <dd>{answers.xdrEnabled ? "Yes" : "No"}</dd>
                            <div
                              className="sub-catg"
                              hidden={!answers.xdrEnabled}
                            >
                              <dt>Config Name:</dt>
                              <dd>{XDRConfigObj.endpointName}</dd>
                              <br />
                              <dt>Endpoint URL:</dt>
                              <dd className="word-set">
                                {XDRConfigObj.endpointAddress}
                              </dd>
                              <br />
                              <dt>Deliver MDN:</dt>
                              <dd>{XDRConfigObj.mdnForward ? "Yes" : "No"}</dd>
                              <br />
                              <dt>Deliver Message Body for XDM Messages:</dt>
                              <dd>{XDRConfigObj.sendXDMBody ? "Yes" : "No"}</dd>
                            </div>
                          </dl>
                        ) : null}
                        {answers.applicationAccessXDR ? (
                          <>
                            <dt>Outbound XDR</dt>
                            <br />
                          </>
                        ) : null}
                        <div className="sub-catg">
                          <dt>Create Direct Automatically:</dt>
                          <dd>{answers.isEpicOrganization ? "Yes" : "No"}</dd>
                          <br />
                          {/*<label htmlFor=" Oon">Out of Network:</label>*/}
                          {/*<span>{answers.outOfNetwork ? "Yes" : "No"}</span>*/}

                          <dt htmlFor=" XdmDeliver">XDM Delivery:</dt>
                          <dd>{!answers.xdrDoNOTGenerateXDM ? "Yes" : "No"}</dd>
                        </div>
                      </>
                    ) : null}
                  </dl>
                </section>
                {/*Certificates*/}
                <section aria-labelledby="certificatesTitle">
                  <div className="field-wrapper label-divider">
                    <h6
                      className="spacer-inline sp-pad9"
                      id="certificatesTitle"
                    >
                      Certificates
                    </h6>
                    <div className="sp-margin3 spacer-inline float-r">
                      <details data-popover="up">
                        <summary>
                          <i
                            className="bi bi-info-circle text-size9"
                            aria-hidden="true"
                          ></i>
                        </summary>
                        <div role="note">
                          <div className="icon-sign or-clr">
                            <i
                              className="bi bi-info-circle"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <p className="sp-margin4">
                            Transport Layer Security (TLS) and its predecessor,
                            Secure Sockets Layer (SSL), both frequently referred
                            to as 'ssl', are cryptographic protocols that
                            provide communications security over a computer
                            network.
                          </p>
                          In Public Key Infrastructure (PKI) systems, a
                          Certificate Signing Request (also CSR or certification
                          request) is a message sent from an applicant to a
                          Certificate Authority in order to apply for a digital
                          identity certificate.
                        </div>
                      </details>
                    </div>
                  </div>
                  <div className="field-wrapper">
                    <dl>
                      <dt>
                        <label htmlFor="IsCsrOrg">Enable CSR Upload:</label>
                      </dt>
                      <dd>
                        <input
                          type="checkbox"
                          name="IsCsrOrg"
                          id="IsCsrOrg"
                          checked={answers.isCsrOrg}
                          value={answers.isCsrOrg}
                          onChange={(el) => {
                            SetSharedObject("CSRUploadPage", "Enable");
                            if (!el.target.checked) {
                              $("#UncheckCSRmodal").modal("show");
                            } else {
                              $("#orgCSRModal").modal("show");
                            }
                          }}
                        />
                      </dd>
                      <br />

                      <dt>Organization TLS Cert:</dt>
                      <dd>
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          aria-label="Download Organization TLS Certificate"
                          onClick={() => downloadTLS()}
                        >
                          Download
                        </button>
                        {sharedObject.CSRUploadFlag ? (
                          <>
                            {" "}
                            |{" "}
                            <button
                              type="button"
                              className="btn btn-link p-0"
                              aria-label="Replace CSR Certificate"
                              onClick={() => {
                                SetSharedObject("CSRUploadPage", "Replace");
                                $("#orgCSRModal").modal("show");
                              }}
                            >
                              Replace CSR
                            </button>
                          </>
                        ) : null}
                      </dd>
                      <br />
                      <dt>PIN for TLS Cert:</dt>
                      <dd>
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={() => viewPIN()}
                          aria-label="View TLS Certificate PIN"
                        >
                          View
                        </button>
                      </dd>
                      <br />

                      <dt>Type:</dt>
                      <dd>
                        {orgDetails.tlsCertExists
                          ? "SES Generated (TLS)"
                          : null}
                      </dd>
                    </dl>
                    {errCreateMsg ? (
                      <div
                        className={`alert alert-danger`}
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        {msg}
                      </div>
                    ) : null}
                  </div>
                </section>

                {/*ID Info*/}
                <section aria-labelledby="idInfoTitle">
                  <div className="label-divider">
                    <h6 className="sp-pad9 spacer-inline" id="idInfoTitle">
                      ID
                    </h6>
                    <div className="v-set2 spacer-inline float-r">
                      <button
                        className="btn btn-info min-wsm"
                        type="button"
                        aria-controls="ID-form"
                        aria-expanded={collapse}
                        aria-label={
                          collapse ? "Collapse ID form" : "Expand ID form"
                        }
                        onClick={(el) => {
                          SetCollapse(!collapse);
                        }}
                      >
                        <i
                          className={`bi ${!collapse ? "bi-plus" : "bi-dash"}`}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </div>
                  </div>
                  <div
                    id="ID-form"
                    className={`field-wrapper ${!collapse ? "collapse" : null}`}
                  >
                    <label htmlFor="id-type-select">ID Type:</label>
                    <select
                      id="id-type-select"
                      className="form-control w-md2 sp-margin13 spacer-inline sp-margin5"
                      onChange={(el) => {
                        SetIDsValue(el.target.value);
                        SetSecondValue("");
                        SetNotExists(true);
                        if (el.target.value === "NPI") {
                          SetThirdValue("CMS");
                        } else {
                          SetThirdValue("");
                        }
                      }}
                    >
                      <option value={""}>Select</option>
                      <option value={"NPI"}>NPI</option>
                      <option value={"State"}>State License</option>
                      <option value={"Other"}>Other</option>
                    </select>
                    {IDsValue === "State" ? (
                      <>
                        <label htmlFor="issuing-state-select">
                          Issuing State:
                        </label>
                        <select
                          id="issuing-state-select"
                          className="form-control w-md2 sp-margin13 spacer-inline"
                          value={secondValue}
                          onChange={(el) => SetSecondValue(el.target.value)}
                        >
                          <option value={""}>Issuing State</option>
                          {stateCodeArray.map((el) => (
                            <option key={el} value={el}>
                              {el}
                            </option>
                          ))}
                        </select>
                        <label htmlFor="state-id-value">ID Value:</label>
                        <input
                          id="state-id-value"
                          className="form-control sp-margin13"
                          type="text"
                          placeholder="Enter Value"
                          value={thirdValue}
                          onChange={(el) => SetThirdValue(el.target.value)}
                        />
                      </>
                    ) : IDsValue === "" ? null : (
                      <>
                        <label htmlFor="id-value-input">
                          {IDsValue === "NPI" ? "NPI Number:" : "ID Value:"}
                        </label>
                        <input
                          id="id-value-input"
                          className="form-control w-md2 sp-margin13 spacer-inline"
                          maxLength={IDsValue === "NPI" ? 10 : 16}
                          value={secondValue}
                          onChange={(el) => {
                            let vl = el.target.value;
                            let chk = isNumeric(vl);
                            if (chk && IDsValue === "NPI") {
                              SetSecondValue(el.target.value);
                            } else if (IDsValue === "Other") {
                              SetSecondValue(el.target.value);
                            }
                          }}
                          type={IDsValue === "NPI" ? "tel" : "text"}
                          placeholder={
                            IDsValue === "NPI"
                              ? "10 digit number"
                              : "Enter Value"
                          }
                        />
                        <label htmlFor="issuing-authority-input">
                          {IDsValue === "NPI"
                            ? "Issuing Authority (CMS):"
                            : "Issuing Authority:"}
                        </label>
                        <input
                          id="issuing-authority-input"
                          className="form-control sp-margin13"
                          type="text"
                          disabled={IDsValue === "NPI"}
                          value={thirdValue}
                          onChange={(el) => SetThirdValue(el.target.value)}
                          placeholder={
                            IDsValue === "NPI"
                              ? "CMS"
                              : " Enter Issuing Authority"
                          }
                        />
                      </>
                    )}
                    {!notExists ? (
                      <div
                        className="alert alert-danger"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        We could not connect or find NPI {secondValue} you
                        entered. Please double check your number and try again.
                      </div>
                    ) : null}
                    {addIdFlag &&
                    IDsValue === "NPI" &&
                    secondValue.length < 10 ? (
                      <div
                        className="alert alert-danger"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        NPI must have 10 numbers.
                      </div>
                    ) : null}
                    {addIdFlag &&
                    ((IDsValue === "State" && thirdValue === "") ||
                      (IDsValue === "Other" && secondValue === "")) ? (
                      <div
                        className="alert alert-danger"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        ID value is required.
                      </div>
                    ) : null}
                    <button
                      className="btn btn-success sp-margin13"
                      type="button"
                      disabled={
                        IDsValue === ""
                          ? true
                          : IDsValue === "NPI" && secondValue.length < 10
                            ? true
                            : IDsValue === "State" &&
                                (secondValue === "" || thirdValue === "")
                              ? true
                              : IDsValue === "Other" && secondValue === ""
                                ? true
                                : false
                      }
                      onClick={(e) => AddId()}
                    >
                      Add
                    </button>
                  </div>
                  <table className="o-flow" aria-label="Identity documents">
                    <caption className="sr-only">
                      Identity documents associated with this organization
                    </caption>
                    <thead>
                      <tr>
                        <th scope="col" className="w-sm">
                          Type
                        </th>
                        <th scope="col">Value</th>
                        <th scope="col">Issuing Authority</th>
                        <th scope="col" className="ctr">
                          Remove
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {answers?.iDs?.map((el) => (
                        <tr key={el.recordId}>
                          <td>{el.idTypeString}</td>
                          <td>{el.value}</td>
                          <td>{el.issuingAuthority}</td>
                          <td
                            className="ctr click-box"
                            onClick={(e) => DeleteId(el)}
                          >
                            <i
                              className="bi bi-x-circle rd-clr"
                              aria-hidden="true"
                            ></i>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {answers?.iDs?.length === 0 ? (
                    <div className="sub-catg" role="status">
                      There are no IDs created for this user.
                    </div>
                  ) : null}
                </section>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseDetailOrg}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/*Certificate Uncheck CSR Upload Confirmation*/}
      <div
        className="modal fade"
        id="UncheckCSRmodal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="confirmationCSRTitle"
        aria-describedby="uncheckCSRDescription"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title or-clr" id="confirmationCSRTitle">
                Attention!
              </h2>
              <button
                type="button"
                className="close"
                aria-label="Close CSR Confirmation"
                onClick={() => {
                  CloseUncheckCSRmodal();
                  SetSharedObject("CSRUploadFlag", true);
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="descript2-container" id="uncheckCSRDescription">
                Unchecking this option will delete current CSR-based certificate
                and default back to TLS Certificate from this organization.
              </div>
              {uncheckMsg ? (
                <div
                  className={`alert alert-danger`}
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                >
                  {msg}
                </div>
              ) : null}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                aria-label="Confirm delete CSR certificate"
                onClick={(e) => UncheckCSR()}
              >
                Confirm
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => {
                  CloseUncheckCSRmodal();
                  SetSharedObject("CSRUploadFlag", true);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* TLS PIN Modal */}
      <div
        className="modal fade"
        id="TlsPinModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tlsPinModalTitle"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="tlsPinModalTitle">
                Organization TLS PIN
              </h3>
              <button
                type="button"
                className="close"
                onClick={CloseTlsPinModal}
                aria-label="Close Dialog"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body ctr">
              <p id="tlsPinModalDesc" className="sr-only">
                The TLS PIN for this organization is shown below.
              </p>
              <p className="sp-margin6 text-size4">{PINValue}</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseTlsPinModal}
                aria-label="Close TLS PIN"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Two-Factor Signup Modal */}
      <div
        className="modal fade"
        id="TwoFactorSignupModal"
        data-backdrop="false"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="twoFactorSignupModalTitle"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="twoFactorSignupModalTitle">
                Two-Factor Authentication
              </h3>
              <button
                type="button"
                className="close"
                onClick={CloseTwoFactorModal}
                aria-label="Close Dialog"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p id="twoFactorSignupModalDesc" className="sr-only">
                Information about signing up for two-factor authentication.
              </p>
              <div className="ctr title-2">
                <img
                  src={TwoFactorIcon}
                  alt="Two-Factor Authentication badge"
                />
                <p className="sp-margin4">
                  Sign Up for Two-Factor Authentication
                </p>
              </div>
              <div className="modal-content-body descript-p">
                <div className="sp-margin3 text-reg">
                  <p>
                    Two-factor Authentication enhances the security of your
                    users by providing additional authentication code to protect
                    their account.
                  </p>
                  <p>
                    Setting up Two-Factor Authentication for your organization
                    will provide the capability to enable any users in your
                    organization with this added security. Contact your account
                    manager to find out how to sign up.
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseTwoFactorModal}
                aria-label="Close Two-Factor Authentication information"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {processingDetails ? (
        <div
          className="loader-container"
          role="status"
          aria-live="polite"
          aria-atomic="true"
          aria-labelledby="org-details-loader"
        >
          <div className="spinner" aria-hidden="true"></div>
          <div className="loading-text" id="org-details-loader">
            {loadingText}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default DetailsOrg;
